import React, { ReactNode, useReducer } from 'react';
import { OrderStatus } from '../app/enums';
import { OrderAction, orderReducer } from '../reducers/orderReducer';
import { Order, OrderItem } from '../models/order.interface';

export interface OrderContextType {
  orderId: string,
  displayOrder: Order,
  orderList: Order[],
  totalAmount: number,
  itemCount: number,
}

export const defaultOrderItem: OrderItem = {
  id: '',
  keyType: '',
  price: 0,
  quantity: 0,
  searchId: '',
  status: OrderStatus.SUBMITTED
}

export const defaultOrderDisplay: Order ={
  id: '',
  userId: '',
  locationId: '',
  createdAt: '',
  status: '',
  orderNumber: '',
  items:[]
}

export const defaultOrderContext: OrderContextType = {
  orderId: '',
  orderList: [],
  displayOrder: defaultOrderDisplay,
  totalAmount: 0,
  itemCount: 0
};

export const OrderContext = React.createContext<{
  state: OrderContextType;
  dispatch: React.Dispatch<OrderAction>
}>({
  state: defaultOrderContext,
  dispatch: () => undefined,
});

export type Props = {
  children: ReactNode;
};

export const OrderContextProvider = ({ children }: Props) => {
  const [ state, dispatch] = useReducer(orderReducer, defaultOrderContext);

  return (
    <OrderContext.Provider value={{state, dispatch}}>
      {children}
    </OrderContext.Provider>
  );
};

export function useOrderContext() {
  const context = React.useContext(OrderContext)
  
  if(context === undefined){
    throw new Error('useOrderContext must be used within a OrderContextProvider')
  }

  return context;
}
  
export default { OrderContextProvider, useOrderContext };
